<template>
  <div id="app">
    <div v-if="!$route.meta.hideTitle">
      <div class="fixed-top fs6 text-center pr7 bc-default" >
          <span id="pageTitle">{{$route.meta.title||''}}</span>
          <div @click="logout" class="logout fs2 pr5 pl5">退出</div>
      </div>
      <div class="place-holder"></div>
    </div>
    <div>
      <keep-alive :include="cachePages">
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import storage from './uitls/cacheUtil';

export default Vue.extend({
  data() {
    return {
      cachePages: [],
      list: [
        'QuotationList',
        'Login',
      ],
    };
  },
  components: {
  },
  computed: {
    // showLogout() {
    //   console.log(storage,this.$route);
    //   return !this.list.includes(this.$route.name);
    // },
  },
  methods: {
    logout() {
      storage.local.set('token', '');
      storage.local.set('type', '');
      this.$router.push('/login');
    },
  },
});
</script>
<style>
#app {
  text-align: center;
  background-color: #f8f8f8;
}
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  /* border-radius: 50%; */
  /* box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5); */
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* color: #ffffff; */
  /* background-color: #ff976a; */
  z-index: 999;
}
.place-holder {
  height: 40px;
}
.logout {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
;}
</style>
